<template>
  <v-container v-if="show">
    <v-card
        class="pa-3 mx-auto"
        width="420"
    >
      <v-text-field
          v-model="email"
          label="Email адрес:"
          id="login"
          :rules="[rules.required, rules.email]"
      >
      </v-text-field>
      <v-text-field
          v-model="password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          name="input-10"
          id="password"
          label="Пароль:"
          counter
          @click:append="show1 = !show1"
      ></v-text-field>
      <v-btn data-test-id="loginSubmit" :disabled="!canCheck" @click="checkAuth()">вход</v-btn>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: [
    'show'
  ],
  data () {
    return {
      rules: {
        required: value => !!value || 'Required.',
        min: v => v && v.length >= 8 || 'Min 8 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      show1: false,
      email: '',
      password: '',
    }
  },
  computed: {
    canCheck(){
      return this.email && this.password
    }
  },
  methods: {
    checkAuth() {
      const authData = { email: this.email, password: this.password }
      this.$store.dispatch('login/checkAuthData', authData).then(() => this.$router.push('/'))
    }
  }
}
</script>